class CartPage {
  constructor() {
    this.init();
  }

  clickEvent = () => {
    // document.querySelector('#checkout-button').addEventListener('click', (event) =>{
    //   let target = document.querySelector('#cart_attribute')
    //   let value = target?.value;
    //   if(!value) {
    //       document.querySelector('.error-message')?.classList.remove('hide');
    //       event.preventDefault();
    //   }else {
    //     document.querySelector('.error-message')?.classList.add('hide');
    //   }
    // })

    let select = document.getElementById('cart_attribute');
    select?.addEventListener('change', (event) => {
      console.log(event.target.value);
      if(event.target.value != "") {
        document.querySelector('.warning-message')?.classList.remove('hide');
        document.querySelector('.error-message')?.classList.add('hide');
      }else {
        document.querySelector('.warning-message')?.classList.add('hide');
      }
    });
  }

  init() {
    this.clickEvent();
  }
}
new CartPage;
